<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%;">
      <el-dialog class="dialogwidth" :modal="false" :title="titmc" :visible.sync="dialogVisible" v-dialogDrag
        :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="24">
            <addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="制度名称" prop="zdmc">
              <el-input :disabled="states=='ck'" type="type" class="from-el-input" placeholder="制度名称" v-model.trim="ruleForm.zdmc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="版本号" prop="bbhao">
              <el-input :disabled="states=='ck'" type="type" class="from-el-input" placeholder="版本号" v-model.trim="ruleForm.bbhao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="状态" prop="zt">
              <el-select :disabled="states=='ck'" v-model.trim="ruleForm.zt" class="from-el-input" placeholder="状态">
                <el-option v-for="(item,i) in ztlist" :key="i" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="简要说明" prop="jysm">
              <el-input :disabled="states=='ck'" type="textarea" :rows="3" class="from-el-input" placeholder="简要说明"
                v-model.trim="ruleForm.jysm"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="states=='xz'||states=='bj'">
          <el-col :span="24">
            <div class="titna">
              <span class="addSpan">附件</span>
            </div>
            <div class='fujian'>
              <el-upload class="upload-demo" drag action="" multiple :on-remove="handleRemove" :on-change='changes'
                :file-list="fileList" :limit="5" :auto-upload='false'>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              <div class='fujian fujians' v-if="filetabledata.length!=0">
                <ul class="fjhxlist">
                  <li v-for="(item,i) in filetabledata" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                    <div class="names cz">
                      <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                      <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)"
                        class="btnmargin"></el-button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="states=='ck' && filetabledata.length!=0">
          <el-col :span="24">
            <div class="titna">
              <span class="addSpan">附件</span>
            </div>
            <div class='fujian'>
              <ul class="fjhxlist">
                <li v-if="filetabledata.length==0" style='width:100%;height:80px;line-height: 80px;color:#ccc'>暂无附件,请上传！</li>
                <li v-for="(item,i) in filetabledata" :key="i" v-if="filetabledata.length!=0">
                  <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                  <div class="names cz">
                    <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                    <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)"
                      class="btnmargin"></el-button>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item type="type" label="登记人" prop="djr">
              <el-input :disabled="states=='ck'" type="type" class="from-el-input" placeholder="登记人" v-model.trim="ruleForm.djr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="登记日期" prop="djsj">
              <el-date-picker :disabled="states=='ck'" v-model.trim="ruleForm.djsj" align="right" type="date"
                value-format="yyyy-MM-dd" class="from-el-input-item" placeholder="登记日期"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button @click="cancel()" v-if="states != 'ck'" type="warning">取 消</el-button>
            <el-button v-if="states == 'xz'" type="success" @click="xzdeteRmine('ruleForm','xz')">保 存</el-button>
            <el-button v-if="states == 'bj'" type="success" @click="xzdeteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>

      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>
<script>
  import {
    ydbjbxxQuery,
    glzdSave,
    glzdUpdate,
    dictioninfo,
    deleteFile
  } from "@/api/api";
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  let date = new Date()
  const currentFdate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  import axios from 'axios'
  export default {
    props: {
      mystate: Array,
    },
    data() {
      return {
        dialogVisible: true, //弹出框显示
        titmc: '防汛管理制度',
        ruleForm: {
          ydbmc: '', //淤地坝名称
          ydbCode: '', //淤地坝编码
          zdmc: '', //制度名称
          bbhao: '', //版本号
          jysm: '',
          zt: '',
          djr: '',
          djsj: String(currentFdate)
        },
        rules: {
          ydbmc: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          zdmc: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          bbhao: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],

          zt: [{
              required: true,
              message: '请输入必填项',
              trigger: 'change'
            },

          ],
          djr: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            },
          ],
          djsj: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            },
          ],
        },

        states: '',
        fullscreen: false,
        ztlist: [],
        fileList: [], //图片
        filetabledata: [], //回显附件
        currentData: '',
        row: null,
        fileUrl: '',
      }
    },
    cerate() {
      //初始化数据
    },
    methods: {
      //获取防汛管理制度状态数字字典
      getglzdztinfo() {
        let params = {
          type: 'fxglzd',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.ztlist = res.data;
        })
      },
      list(params) {
        let _this = this;
        ydbjbxxQuery(params).then((res) => {
          if (res.data.length !== 1) {
            _this.$notify({
              title: "提示",
              message: "请选择淤地坝",
              type: "warning"
            });
          } else {
            _this.ruleForm.ydbCode = res.data[0].ydbCode;
            _this.ruleForm.ydbmc = res.data[0].ydbName;
          }
        })
      },
      treeClose() {
        // let params = {};
        // this.list(params);
      },
      objdata(data) {
        let params = {
          ydbCode: data.ydbCode
        };
        this.list(params);
      },
      //函数
      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
      xzdeteRmine(formName, states) { //确定
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }; // 添加请求头
            if (this.fileList.length != 0) {
              let formData = new FormData();
              this.fileList.forEach((el, index) => {
                formData.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });

              axios.post('/userApi/minio/updateFileMulti', formData, config).then(res => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "success",
                  });
                  this.fileUrl = res.data.data;
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "warning",
                  });
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              if (states == 'xz') {
                let params = {
                  ydbName: _this.ruleForm.ydbmc, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbFxglzdMc: _this.ruleForm.zdmc, //防汛管理制度名称
                  ydbBbh: _this.ruleForm.bbhao, //版本号
                  ydbJysm: _this.ruleForm.jysm, //简要说明
                  fileList: _this.fileUrl, //附件
                  ydbDjr: _this.ruleForm.djr, //登记人
                  ydbDjqr: _this.ruleForm.djsj, //登记日期
                  status: _this.ruleForm.zt, //状态
                };
                glzdSave(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("adddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              } else {
                let zhuangtai;
                if (_this.ruleForm.zt === '有效') {
                  zhuangtai = 0;
                } else {
                  zhuangtai = 1;
                }
                let params = {
                  ydbName: _this.ruleForm.ydbmc, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbFxglzdMc: _this.ruleForm.zdmc, //防汛管理制度名称
                  ydbBbh: _this.ruleForm.bbhao, //版本号
                  ydbJysm: _this.ruleForm.jysm, //简要说明
                  fileList: _this.fileUrl, //附件
                  ydbDjr: _this.ruleForm.djr, //登记人
                  ydbDjqr: _this.ruleForm.djsj, //登记日期
                  status: zhuangtai, //状态
                  id: _this.row.id
                };
                if (params.fileList === '') {
                  params.fileList = null;
                }
                glzdUpdate(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("bjadddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              }
            }, 200)
          }
        });
      },

      DownloadFile(index, row) { //下载文件
        window.open("/userApi/minio/downloadFile/" + row.fileName);
      },
      deletesfile(index, row) { //删除文件
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
        		this.filetabledata.splice(index, 1)
        	}
        })
      },

      handleRemove(file, fileList) { //删除文件
        for (let i = 0; i < this.fileList.length; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(this.fileList[i], 1);
          }
        }
      },
      changes(file, fileList) {
        let num = 1024.00;
        if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
          fileList.splice(fileList.length - 1, 1);
          this.$message.error('选择文件大于10M，请重新选择！');
        } else {
          this.fileList.push(file.raw);
        }
      },
    },
    components: {
      //引入组件
      addressTree
    },
    mounted() {
      this.getglzdztinfo();
      //实例挂载后
      this.states = this.mystate[0];
      this.row = this.mystate[1];
      if (this.states == 'bj' || this.states == 'ck') {
        this.currentData = this.mystate[1].ydbName; //淤地坝名称

        this.ruleForm.ydbmc = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.zdmc = this.mystate[1].ydbFxglzdMc; //防汛管理制度名称
        this.ruleForm.bbhao = this.mystate[1].ydbBbh; //版本号
        this.ruleForm.jysm = this.mystate[1].ydbJysm; //简要说明
        // this.ruleForm.fileList = this.mystate[1].ydbFuJian; //附件
        this.ruleForm.djr = this.mystate[1].ydbDjr; //登记人
        this.ruleForm.djsj = this.mystate[1].ydbDjqr; //登记日期

        this.filetabledata = this.mystate[1].fileList;

        if (this.mystate[1].status === 0) {
          this.ruleForm.zt = '有效'; //状态
        } else {
          this.ruleForm.zt = '无效'; //状态
        }
      }
    },
  }
</script>

<style scoped>
  .fujian {
    width: -webkit-calc(100% - 102px);
    width: -moz-calc(100% - 102px);
    width: calc(100% - 102px);
    float: left;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;

  }

  .treebox {
    width: 100%;
    margin: 0;
  }

  >>>.el-dialog {
    width: 600px;
  }

  >>>.el-input.is-disabled .el-input__inner {
    color: #606266;
  }

  >>>.el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }

  >>>.el-input--prefix .el-input__inner {
    padding-left: 30px;
  }
</style>
